export default "__VITE_ASSET__BdCYj4v8__"